/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import About from "../About/About";
import {
    Box,
    Container,
    Flex,
    HStack,
    Image,
    Text,
    Stack,
} from "@chakra-ui/react";
import { Tabs, TabList, Tab, TabIndicator } from "@chakra-ui/react";
import infoIcon from "../../assets/info.svg";

const navItems = [
    { path: "/", title: "Interactive Displays" },
    { path: "/cde", title: "Commercial Displays" },
    { path: "/allInOne", title: "All-in-One LED Displays" },
];

function Header() {
    const [open, setOpen] = useState(false);
    const history = useNavigate();
    const location = useLocation(); // 使用 useLocation 獲取當前路由
    const [active, setActive] = useState({
        "/": true,
        "/cde": false,
        "/allInOne": false,
    });
    const activeIndex = Object.values(active).findIndex((value) => value);

    const handleClicked = (path) => {
        setActive((prev) => {
            const newActive = {};
            for (let key in prev) {
                newActive[key] = key === path;
            }
            return newActive;
        });
        history(path);
    };

    useEffect(() => {
        setActive((prev) => {
            const newActive = {};
            const currentPath = location.pathname.endsWith("/")
                ? location.pathname.slice(0, -1)
                : location.pathname;
            for (let key in prev) {
                const trimmedKey = key.endsWith("/") ? key.slice(0, -1) : key;
                newActive[key] = trimmedKey === currentPath;
            }
            return newActive;
        });
    }, [location.pathname]);

    return (
        <>
            <About setOpen={setOpen} open={open}></About>
            <Container
                maxW="full"
                position="sticky"
                top={0}
                h="auto"
                p="15px"
                zIndex={1000}
                overflowX="hidden"
                boxShadow="lg"
                bgColor="white"
                centerContent
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    w="full"
                >
                    <Stack spacing={0} direction="row" gap="2px">
                        <Text
                            m="0px"
                            fontSize="18.976px"
                            letterSpacing="-0.569px"
                            alignItems="center"
                            fontFamily="GothamBook"
                            fontWeight="400"
                        >
                            View
                        </Text>
                        <Text
                            m={0}
                            fontSize="18.976px"
                            alignItems="center"
                            fontFamily="GothamBold"
                            fontWeight="700"
                            letterSpacing="-14%"
                        >
                            AR
                        </Text>
                    </Stack>
                    <Box
                        as="button"
                        type="button"
                        aria-label="App help and onboarding"
                        onClick={() => setOpen(true)}
                        cursor="pointer"
                        p={0}
                        lineHeight={0}
                        bg="transparent"
                        border="none"
                    >
                        <Image
                            src={infoIcon}
                            alt=""
                            w="30px"
                            h="30px"
                            display="block"
                        />
                    </Box>
                </Stack>
                <Text
                    w="full"
                    m={0}
                    mt="32px"
                    mb="17px"
                    fontSize="18px"
                    fontWeight="600"
                >
                    Select your product
                </Text>

                <Flex
                    w="full"
                    className="hide-scorllbar"
                    cursor="grab"
                    whiteSpace="nowrap"
                >
                    <Tabs
                        h="42px"
                        position="relative"
                        variant="unstyled"
                        index={activeIndex}
                    >
                        <TabList>
                            <Flex>
                                {navItems.map((item) => (
                                    <Tab
                                        p={2.5}
                                        fontFamily="body"
                                        fontSize="18px"
                                        fontWeight="semibold"
                                        key={item.path}
                                        onClick={() => handleClicked(item.path)}
                                        variant="none"
                                    >
                                        <Text
                                            m={0}
                                            as="h4"
                                            color={
                                                active[item.path]
                                                    ? "black"
                                                    : "#B2B2B2"
                                            }
                                        >
                                            {item.title}
                                        </Text>
                                    </Tab>
                                ))}
                            </Flex>
                        </TabList>
                        <TabIndicator mt="-3px" height="2px" bg="#0057B8" />
                    </Tabs>
                </Flex>
            </Container>
        </>
    );
}

export default Header;
